import { formatDate } from '@utils/date-utils';

/** Removes characters invalid in download filenames; preserves spaces and existing punctuation. */
export function cleanseDownloadFilename(filename: string): string {
  return filename.replace(/[/\\:*?"<>|]/g, '');
}

export interface DateRangedExportFileNameOptions {
  /** File extension without the leading dot. Defaults to `xlsx`. */
  fileExtension?: string;
  /** Label used when there is no end date. Defaults to `Present`. */
  openEndedLabel?: string;
  /** Moment format for the effective dates. Defaults to `MM-YYYY`. */
  dateFormat?: string;
}

/**
 * Builds an export filename with an effective date range.
 * Format: `[Export Label] - [Name] [EFD] to [ETD].[extension]`
 */
export function buildDateRangedExportFileName(
  exportLabel: string,
  name: string,
  effectiveFromDate: string | null | undefined,
  effectiveToDate: string | null | undefined,
  options: DateRangedExportFileNameOptions = {}
): string {
  const {
    fileExtension = 'xlsx',
    openEndedLabel = 'Present',
    dateFormat = 'MM-YYYY'
  } = options;

  const effectiveFrom = formatDate(effectiveFromDate, dateFormat);
  const effectiveTo = effectiveToDate ? formatDate(effectiveToDate, dateFormat) : openEndedLabel;

  return `${exportLabel} - ${name} ${effectiveFrom} to ${effectiveTo}.${fileExtension}`;
}
